import { render, staticRenderFns } from "./GroupControls.vue?vue&type=template&id=ef8c5c7a"
import script from "./GroupControls.vue?vue&type=script&lang=js"
export * from "./GroupControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports